import { isArray, isString } from 'lodash'
import type { TextFeatureVariable } from '../types'

/**
 * Extracts the string text content from a TextFeatureVariable
 *
 * @param variable - The TextFeatureVariable to extract text from
 * @returns A string representation of the variable's text content
 */
export const getTextFromTextFeatureVariable = (
  variable: TextFeatureVariable,
): string => {
  if (!variable) return ''

  if (isString(variable)) return variable

  if (isArray(variable)) return variable.map((item) => item.copy).join('')

  return variable.copy
}
